export default __webpack_public_path__ + "static/account_desktop@2x-14fab44a8f4ade35fbcd294b2da7260f.png";